/* ===== START: PASSWORD PAGE — ?login reveals the password box =====
   Temporary; retire with the coming-soon landing page. Loaded only by layout/password.liquid.
   Adds .wt-password-login to <body> so the custom.css hide rule stops applying, then opens
   the <details>. Reveals the field; the storefront password is still required. */
(function () {
  if (!/(^|[?&])login(=|&|$)/.test(window.location.search)) return;

  function reveal() {
    document.body.classList.add('wt-password-login');

    var modal = document.querySelector('.password-header password-modal details');
    if (!modal) return;
    modal.open = true;

    var field = modal.querySelector('input[type="password"]');
    if (field) field.focus();
  }

  // Guard so the script also works without `defer`.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
/* ===== END: PASSWORD PAGE ===== */
